import React from "react";
import Table from 'react-bootstrap/Table';
import VideoInterferencia from "../VideoInterferencia";
import Sinal from "../../../assets/images/sinal.gif";


import './styles.css';

const Interferencias = () => {

    return (
        <>
            <div className="container">
                <h1>
                    Comunicação wireless - principais barreiras que interferem no sinal
                </h1>
                <span>
                    As ondas emitidas pelas antenas dos componentes da rede sem fios são muito sensíveis a barreiras,
                    por isso, o ideal é que não exista nenhum obstáculo físico entre elas.
                    <br />
                    Mas, na prática, é muito difícil que isso não ocorra, podendo sempre haver perda de sinal.
                    Isso irá interferir, principalmente, no alcance do sinal e na velocidade de transmissão dos dados.
                </span>
                <h4>Principais fontes de interferencia</h4>
                <p>

                    <ol>
                        <li>Telefones sem fio de 2,4 ou 5 GHz: esses telefones que operam na mesma frequência dos aparelhos sem fio causam interferência no sinal, causando perda de dados ou perda de conexão entre cliente e estação base.</li>
                        <li>Fontes elétricas externas: como estação de energia elétrica e linhas de alimentação.</li>
                        <li>Fontes micro-ondas: utilizar o forno micro-ondas perto de computadores e roteadores Wi-Fi pode causar interferência.</li>
                        <li>Espelho d'água: rios e lagoas refletem muito o sinal, podendo causar severa perda no sinal.</li>
                        <li>Potencial de interferência de certos materiais:
                            <ul>
                                <li>Madeira, gesso, vidro e resina: baixo potencial de interferência. Cerca de 3dB</li>
                                <li>Tijolo e mármore: médio potencial de interferência. Cerca de 6dB</li>
                                <li>Concreto e vidro blindado: alto potencial de interferência. Cerca de 8dB</li>
                                <li>Metal: o mais alto potencial de interferência. Cerca de 19dB</li>
                            </ul>
                        </li>
                    </ol>
                    <p>Esses valores podem variar para mais ou para menos</p>
                </p>
                <VideoInterferencia />
                <br /><br />
                <h1>Planejamento de Rede Wi-Fi</h1>
                <h4>
                    Devido às diversas interferências causadas pelo ambiente onde a rede será instalada,
                    é crucial planejar para oferecer a cobertura ideal para cada tipo de atividade na internet.
                </h4>
                <br /><br />
                <h5>Planejamento:</h5>
                <p>
                    A chave para uma implantação de rede sem fio bem-sucedida é o planejamento adequado,
                    que envolve a definição de metas e requisitos específicos a serem alcançados. Uma das
                    etapas essenciais é a determinação dos requisitos mínimos de intensidade de sinal dentro
                    da área de cobertura, que quase sempre faz parte da lista de requisitos da rede.
                </p>
                <br /><br />
                <h5>Requisitos e variáveis</h5>
                <p>
                    A intensidade ideal do sinal varia de acordo com vários fatores, incluindo o ambiente com possíveis
                    interferências, o número de dispositivos na rede, as taxas de dados necessárias e os aplicativos em
                    uso. Por exemplo, um sistema VoIP pode requerer uma cobertura mais
                    robusta do que um sistema de scanner de código de barras em um armazém.
                </p>
                <br />
                <div className="sinal">
                    <h5>Compreendendo a força do sinal</h5>
                    <Table striped bordered hover variant="dark">
                        <thead>
                            <tr>
                                <th>Força</th>
                                <th>Classificação</th>
                                <th>Características</th>
                                <th>Usabilidade</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>-30dBm</td>
                                <td>Excelente</td>
                                <td>Força máxima do sinal alcançável. Esse cenário só é possível se estiver a apenas alguns metros (mesma sala) do Roteador. Não é típico em o mundo real.</td>
                                <td>Ideal para todo tipo de conteúdo, recomendado para Gamers</td>
                            </tr>
                            <tr>
                                <td>-50dBm</td>
                                <td>Muito Bom</td>
                                <td>Intensidade mínima do sinal para aplicações que exigem muito que a entrega de pacotes de dados seja confiável.</td>
                                <td>VoIP, Streaming de Vídeo, TV</td>
                            </tr>
                            <tr>
                                <td>-67dBm</td>
                                <td>Bom</td>
                                <td>Intensidade mínima do sinal para aplicações leves como sistemas de gestão</td>
                                <td>Sistemas Web com tráfego moderado</td>
                            </tr>
                            <tr>
                                <td>-70dBm</td>
                                <td>Regular</td>
                                <td>Intensidade mínima ao sinal para entrega de pacotes confiáveis.</td>
                                <td>E-mail e navegação em páginas da web</td>
                            </tr>
                            <tr>
                                <td>-80dBm</td>
                                <td>Ruim</td>
                                <td>Intensidade mínima do sinal para conectividade básica. A entrega de pacotes pode não ser confiável.</td>
                                <td>Sem garatias de conteúdo</td>
                            </tr>
                            <tr>
                                <td>-90dBm</td>
                                <td>Inutilizável</td>
                                <td>Nível Crítico, qualquer funcionalidade é altamente improvável.</td>
                                <td>N/D</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <br />
                <div>
                    <h5>
                        Rastreando a Intensidade do Sinal
                    </h5>
                    <p>Para rastrear o sinal, podemos utilizar as ferramentas disponíveis nas lojas de aplicativos como WiFiMan, WiFi Analyzer, etc.</p>
                    <img src={Sinal} alt="sinal" />
                    <p>
                        Utilizando um dos aplicativos de análise de rede em pontos estratégicos do ambiente em implantação obteremos um gráfico como esse acima. Se a linha azul cair abaixo da linha pontilhada, você saberá que tem uma ponto morto. 
                    </p>
                </div>

            </div>

        </>
    );
};
export default Interferencias;